import React, { useState, useEffect } from 'react'
import './ChallengeOverViewGrid.css'
import DpsButton from '../button/DpsButton'
import SaveAltIcon from '@mui/icons-material/SaveAlt'
import { exportDataGridToCsv } from '../../../utills/utils'

function ChallengeOverViewGrid({
  GridComponent,
  gridProps,
  GridPageSizeComponent,
  GridPageSizeProps,
  exportData,
}) {
  const handleDownloadCsv = () => {
    exportDataGridToCsv({
      fileName: 'Challenge_Data',
      dateFields: ['date'],
      rowsData: exportData,
    })
  }
  return (
    <div className="challenge-overview-grid">
      <DpsButton
        startAdronIcon={<SaveAltIcon />}
        buttonVariant="text"
        label="EXPORT"
        buttonType=""
        onClick={handleDownloadCsv}
      />{' '}
      <div className="grid-section">
        <div className="grid-page-size">
          <GridPageSizeComponent {...GridPageSizeProps} />
        </div>
        <div className="grid-data">
          <GridComponent {...gridProps} />
        </div>
      </div>
    </div>
  )
}
export default ChallengeOverViewGrid
